package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ParentNoticeListItemResponse(
    val id: String? = null,
    @SerialName("notice_id") val noticeId: String? = null,
    val title: String? = null,
    @SerialName("applicable_to") val applicableTo: String? = null,
    @SerialName("published_on") val publishedOn: String? = null,
    @SerialName("expiry_date") val expiryDate: String? = null,
    val status: String? = null
)
